import { ref, defineComponent, onMounted, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/store/auth.store';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import useEmitter from '@/hooks/use-emitter';
import { setTimezone } from '@marfa/bo-utils';

export default defineComponent({
  name: 'Root',
  props: {
    wlSlug: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    multibrandApiUrl: {
      type: String,
      required: true,
    },
    servicePermissions: {
      type: String,
      default: '',
    },
    currentParentRouteName: {
      type: String,
      default: '',
    },
    whitelabelId: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { token } = storeToRefs(useAuth());
    const root = ref();
    const { go } = useRouter();
    const { setEnv } = useEnvStore();
    const { setupRootEmitter } = useEmitter();

    const isBackofficeMode = computed(() => {
      return !!props.wlSlug && !!props.apiUrl;
    });

    onMounted(() => {
      if (!token.value && isBackofficeMode.value) {
        go(0);
      }

      setEnv(props);

      setupRootEmitter((name, value) =>
        root.value.parentNode.dispatchEvent(new CustomEvent(name, { detail: value })),
      );

      const timezone = localStorage.getItem('adminTimezone');

      if (timezone) {
        setTimezone(timezone);
      }
    });

    watch(props, (updatedProps) => {
      setEnv(updatedProps);
    });

    return {
      root,
    };
  },
});
